import { addDays, addMonths, addWeeks, format, isValid, parse, parseISO } from 'date-fns'

const MINIMUM_ELIGIBLE_PERIOD_PATTERN = /minimum eligible period/i

const HIRE_DATE_FIELDS = [
  'joined_date',
  'join_date',
  'hiring_date',
  'hire_date',
  'employment_date',
  'date_of_join',
  'start_date',
]

const getPolicyEligibility = (selectedLeave) => {
  const eligibleAmount =
    selectedLeave?.leave_policy?.eligible_amount ?? selectedLeave?.eligible_amount ?? null
  const eligiblePeriod =
    selectedLeave?.leave_policy?.eligible_period ?? selectedLeave?.eligible_period ?? null

  return {
    eligibleAmount: Number(eligibleAmount) || 0,
    eligiblePeriod,
  }
}

const parseStaffHireDate = (staff = {}) => {
  for (const field of HIRE_DATE_FIELDS) {
    const value = staff?.[field]
    if (!value) continue

    const parsedDate =
      typeof value === 'string' && value.includes('/')
        ? parse(value, 'dd/MM/yyyy', new Date())
        : parseISO(String(value))

    if (isValid(parsedDate)) {
      return parsedDate
    }
  }

  return null
}

const getEligibleDate = (hireDate, eligibleAmount, eligiblePeriod) => {
  if (!hireDate || !eligibleAmount || !eligiblePeriod) return null

  if (eligiblePeriod === 'day') return addDays(hireDate, eligibleAmount)
  if (eligiblePeriod === 'week') return addWeeks(hireDate, eligibleAmount)
  if (eligiblePeriod === 'month') return addMonths(hireDate, eligibleAmount)

  return null
}

const formatEligibleWait = (eligibleAmount, eligiblePeriod) => {
  if (!eligibleAmount || !eligiblePeriod) return ''
  const unit = eligibleAmount > 1 ? `${eligiblePeriod}s` : eligiblePeriod
  return `${eligibleAmount} ${unit}`
}

export const getLeaveRequestErrorMessage = ({ errorMessage, selectedLeave, myAccountData }) => {
  if (!errorMessage) return 'Unable to submit leave request.'

  if (!MINIMUM_ELIGIBLE_PERIOD_PATTERN.test(errorMessage)) {
    return errorMessage
  }

  const { eligibleAmount, eligiblePeriod } = getPolicyEligibility(selectedLeave)

  if (!eligibleAmount || !eligiblePeriod) {
    return "You're not eligible for this leave yet. Please check the leave policy requirements."
  }

  const staff = myAccountData?.data?.staff ?? myAccountData?.staff ?? null
  const hireDate = parseStaffHireDate(staff)
  const eligibleDate = getEligibleDate(hireDate, eligibleAmount, eligiblePeriod)
  const formattedWait = formatEligibleWait(eligibleAmount, eligiblePeriod)

  if (eligibleDate && isValid(eligibleDate)) {
    return `You're not eligible for this leave yet. This leave is available ${formattedWait} after your hiring date, starting on ${format(eligibleDate, 'd MMMM yyyy')}.`
  }

  return `You're not eligible for this leave yet. This leave is available ${formattedWait} after your hiring date.`
}

export default getLeaveRequestErrorMessage
